import React from 'react';
import HeroSection from '../components/Home/HeroSection';
import ServiceCards from '../components/Home/ServiceCards';
import Statistics from '../components/Home/Statistics';
import ContentSections from '../components/Home/ContentSections';

const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <ServiceCards />
      <Statistics />
      <ContentSections />
    </>
  );
};

export default Home;

